module.exports = {"610802001":"鼓楼街道","610802002":"青山路街道","610802003":"上郡路街道","610802004":"新明楼街道","610802005":"驼峰路街道","610802006":"崇文路街道","610802007":"航宇路街道","610802008":"长城路街道","610802100":"鱼河镇","610802101":"上盐湾镇","610802102":"镇川镇","610802105":"麻黄梁镇","610802106":"牛家梁镇","610802107":"金鸡滩镇","610802108":"马合镇","610802109":"巴拉素镇","610802111":"鱼河峁镇","610802112":"青云镇","610802113":"古塔镇","610802114":"大河塔镇","610802115":"小纪汗镇","610802116":"芹河镇","610802205":"孟家湾乡","610802206":"小壕兔乡","610802207":"岔河则乡","610802208":"补浪河乡","610802209":"红石桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610802.json
// module id = 2649
// module chunks = 0